<div class="flex-row flex" style="overflow-x: auto">
    <div class="cb-padding-left-3x cb-padding-right-3x cb-padding-bottom-3x flex-col flex-100">
        <div class="start-center flex-row">
            <h3 class="mat-headline-6 flex">Search Indexes</h3>
        </div>
        <cb-table [loaded]="true" [stringColumns]="columns">
            @for (index of indexes; track index) {
                <tr cbTableRow>
                    <cb-td-text [value]="index.label"></cb-td-text>
                    <td cbTableStickyCol="end" cbTableShrinkCol>
                        <button
                            mat-icon-button
                            [disabled]="getDisabled(index)"
                            (click)="resetIndex(index)"
                        >
                            <mat-icon> cached </mat-icon>
                        </button>
                    </td>
                </tr>
            }
        </cb-table>
    </div>
</div>
